import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <path d="M24.5 26V17.5L29.5 12.5V6.5L25.5 2.5L24.5 3.5V7.5L23.5 8.5H18.5L17.5 7.5V3.5L16.5 2.5L12.5 6.5V12.5L17.5 17.5V42.5C17.5 44.2 18.8 45.5 20.5 45.5H21.5C22.8467 45.5 23.9424 44.6842 24.3396 43.5M34.5 35V27M39 34.5H34.5M45.5 34.5C45.5 40.6 40.6 45.5 34.5 45.5C28.4 45.5 23.5 40.6 23.5 34.5C23.5 28.4 28.4 23.5 34.5 23.5C40.6 23.5 45.5 28.4 45.5 34.5Z" stroke="black" />

      </svg>

    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <path d="M24.5 26V17.5L29.5 12.5V6.5L25.5 2.5L24.5 3.5V7.5L23.5 8.5H18.5L17.5 7.5V3.5L16.5 2.5L12.5 6.5V12.5L17.5 17.5V42.5C17.5 44.2 18.8 45.5 20.5 45.5H21.5C22.8467 45.5 23.9424 44.6842 24.3396 43.5M34.5 35V27M39 34.5H34.5M45.5 34.5C45.5 40.6 40.6 45.5 34.5 45.5C28.4 45.5 23.5 40.6 23.5 34.5C23.5 28.4 28.4 23.5 34.5 23.5C40.6 23.5 45.5 28.4 45.5 34.5Z" stroke="black" />
    </svg>
  );
};